const devtricker_isToFollowActions = {
    FOLLOW: true,
    UNFOLLOW: false
};

document.addEventListener("DOMContentLoaded", async () => {
    let loggedUserId = devtricker_getTheLoggedUserId();

    if (!loggedUserId) {
        return;
    }

    const followButtons = document.querySelectorAll(".author-follow-button");

    for (let button of followButtons) {
        const buttonUserId = button.getAttribute("data-author-id");

        try {
            const isFollowing = devtricker_session_isFollowing(buttonUserId);
            if (isFollowing) {
                button.innerText = "Following";

                let newOnClick = `devtricker_followUser(event, this, ${devtricker_isToFollowActions.UNFOLLOW})`;
                button.setAttribute('onclick', newOnClick);
            }
        } catch (error) {
            console.error("Failed to check following status:", error);
        }
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const followButtons = document.querySelectorAll(".author-follow-button");

    followButtons.forEach(button => {
        const userId = devtricker_getTheLoggedUserId();
        const buttonUserId = button.getAttribute("data-author-id");

        if (userId !== buttonUserId) {
            button.classList.remove("invisible");
        }
    });
});

document.addEventListener('DOMContentLoaded', async function () {
    devtricker_initializeFollowPostAuthorButtonOnLoad();
    devtricker_initializeFollowerCounterPostAuthorButtonOnLoad();
    devtricker_showFollowAuthorButtonOnLoad();
});

function devtricker_closeAllPopovers() {
    const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
    popovers.forEach((popoverTrigger) => {
        const popoverInstance = bootstrap.Popover.getInstance(popoverTrigger);
        if (popoverInstance) {
            popoverInstance.hide();
        }
    });
}

async function devtricker_updateFollowButtonOptimisticallyAndPersistInIndexedDb(button, userToFollowId, followActionIntention) {
    try {

        await devtricker_validateUserToFollowId(userToFollowId);
        await devtricker_validateFollowAction(followActionIntention);

        let isFollowing = devtricker_session_isFollowing(userToFollowId);

        if (isFollowing && followActionIntention == devtricker_isToFollowActions.UNFOLLOW) {

            await devtricker_session_unfollowUser(userToFollowId);

            devtricker_makeTheFollowButtonReadyToFollow(button);
            devtricker_incrementFollowerCounterPostAuthor(-1, button.getAttribute('data-author-id'));

        } else if (!isFollowing && followActionIntention == devtricker_isToFollowActions.FOLLOW) {

            devtricker_session_followUser(userToFollowId);
            devtricker_makeTheFollowButtonReadyToUnfollow(button);
            devtricker_incrementFollowerCounterPostAuthor(1, button.getAttribute('data-author-id'));

        } else {
            throw new Error('Follow action mismatch. The user is attempting to follow or unfollow when they are already');
        }

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}

async function devtricker_makeTheFollowButtonReadyToUnfollow(button) {

    let userToFollowId = button.getAttribute('data-author-id');

    await devtricker_validateUserToFollowId(userToFollowId);

    button.innerText = 'Following';

    let newOnClick = `devtricker_followUser(event, this, ${devtricker_isToFollowActions.UNFOLLOW})`;

    button.setAttribute('onclick', newOnClick);

    const followButtons = document.querySelectorAll(".author-follow-button");

    for (let button of followButtons) {
        const buttonUserId = button.getAttribute("data-author-id");

        try {

            if (buttonUserId == userToFollowId) {
                button.innerText = "Following";
                button.setAttribute('onclick', newOnClick);
            }
        } catch (error) {
            console.error("Failed to check following status:", error);
        }
    }
}

async function devtricker_makeAllTheFollowButtonsReadyToUnfollow() {

    const followButtons = document.querySelectorAll(".author-follow-button");

    for (let button of followButtons) {

        let userToFollowId = button.getAttribute('data-author-id');
        let isFollowing = devtricker_session_isFollowing(userToFollowId);

        if (isFollowing) {

            button.innerText = 'Following';
            let newOnClick = `devtricker_followUser(event, this, ${devtricker_isToFollowActions.UNFOLLOW})`;
            button.setAttribute('onclick', newOnClick);
        }
    }
}

async function devtricker_makeTheFollowButtonReadyToFollow(button) {

    let userToFollowId = button.getAttribute('data-author-id');

    await devtricker_validateUserToFollowId(userToFollowId);

    button.innerText = 'Follow';

    let newOnClick = `devtricker_followUser(event, this, ${devtricker_isToFollowActions.FOLLOW})`;

    button.setAttribute('onclick', newOnClick);

    const followButtons = document.querySelectorAll(".author-follow-button");

    for (let button of followButtons) {
        const buttonUserId = button.getAttribute("data-author-id");

        try {

            if (buttonUserId == userToFollowId) {
                button.innerText = "Follow";
                button.setAttribute('onclick', newOnClick);
            }
        } catch (error) {
            console.error("Failed to check following status:", error);
        }
    }
}

function devtricker_initializeFollowPostAuthorButtonOnLoad() {
    let followAuthorPostButton = document.getElementById('follow-author-post-button');

    if (followAuthorPostButton) {
        let userId = followAuthorPostButton.getAttribute('data-author-id');

        devtricker_initializeOrUpdateFollowPostAuthorButton(userId);
    }
}

function devtricker_initializeFollowerCounterPostAuthorButtonOnLoad() {
    let followAuthorPostButton = document.getElementById('follow-author-post-button');

    if (followAuthorPostButton) {
        let userId = followAuthorPostButton.getAttribute('data-author-id');

        devtricker_incrementAuthorPostFollowerNumberIfRecent(userId);
    }
}

async function devtricker_initializeOrUpdateFollowPostAuthorButton(userIdToUpdate) {
    let followElements = document.querySelectorAll(
        `#follow-author-post-button[data-author-id="${userIdToUpdate}"], 
         .popover-follow-author[data-author-id="${userIdToUpdate}"]`
    );

    if (followElements.length === 0) {
        return;
    }

    let userId = devtricker_getTheLoggedUserId();

    if (!userId) {
        return;
    }

    let isFollowing = devtricker_session_isFollowing(userIdToUpdate);

    followElements.forEach(element => {
        if (isFollowing) {
            devtricker_makeTheFollowButtonReadyToUnfollow(element);
        } else {
            devtricker_makeTheFollowButtonReadyToFollow(element);
        }
    });
}

async function devtricker_incrementAuthorPostFollowerNumberIfRecent(userIdToUpdate) {
    let currentUserId = devtricker_getTheLoggedUserId();

    if (currentUserId) {

        let isRecent = devtricker_session_isFollowingRecent(userIdToUpdate);

        if (isRecent) {
            devtricker_updateAuthorPostFollowerNumber(1, userIdToUpdate);
        }
    }
}

function devtricker_updateAuthorPostFollowerNumber(delta, userId) {
    let followAuthorPosAnchor = document.querySelector(`.author-followers-link[data-author-id="${userId}"]`);

    if (followAuthorPosAnchor) {
        let currentFollowers = 0;

        if (!isNaN(parseInt(followAuthorPosAnchor.textContent.trim().split(' ')[0]))) {
            currentFollowers = parseInt(followAuthorPosAnchor.textContent.trim().split(' ')[0]);
        }

        let newFollowers = currentFollowers + delta;

        if (newFollowers < 0) {
            newFollowers = 0;
        }

        if (newFollowers === 1) {
            followAuthorPosAnchor.textContent = '1 Follower';
        } else {
            followAuthorPosAnchor.textContent = `${newFollowers} Followers`;
        }
    }
}

function devtricker_incrementFollowerCounterPostAuthor(value, userToFollowId) {

    let followAuthorPosAnchor = document.querySelector(`.author-followers-link[data-author-id="${userToFollowId}"]`);

    if (followAuthorPosAnchor) {
        devtricker_updateAuthorPostFollowerNumber(value, userToFollowId);
    }
}

function devtricker_showFollowAuthorButtonOnLoad() {
    let currentUserId = devtricker_getTheLoggedUserId();

    if (currentUserId) {
        let followButton = document.getElementById('follow-author-post-button');

        if (followButton) {

            let authorId = followButton.getAttribute('data-author-id');

            if (authorId == currentUserId) {
                followButton.style.display = 'none';
            }
        }
    }
}